import { TacticsAndTechniquesView } from '../view/TacticsAndTechniquesView';
import { templateTacticsAndTechniques } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../framework/BaseWebComponentController';
import { TacticsAndTechniquesWebComponent } from '..';
import { MitreTags, TacticsAndTechniquesWebComponentSchema } from '../types';

export class TacticsAndTechniquesController extends BaseWebComponentController {
  public component: TacticsAndTechniquesWebComponent;
  public view: TacticsAndTechniquesView;
  public viewConstructor: typeof TacticsAndTechniquesView;

  constructor(component: TacticsAndTechniquesWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: TacticsAndTechniquesView,
      viewTemplate: templateTacticsAndTechniques,
    });
  }

  async getDataForView(): Promise<TacticsAndTechniquesWebComponentSchema> {
    return {
      mitreTags: this.component.mitreTags as MitreTags,
    };
  }
}
